//
// Hire Form Controller
//

import flatpickr from 'flatpickr'
import { onLoaded } from '../utilities'

export default class HireFormController {
  public static readonly shared = new HireFormController()

  // MARK: - Object Lifecycle

  private constructor() {
    onLoaded(this.mountDatePickers.bind(this))
  }

  // MARK: - Mount / Unmount

  private buildCommonOptions(): flatpickr.Options.Options {
    return {
      allowInput: true,
      altInput: true,
      altFormat: 'd/m/Y h:i K',
      dateFormat: 'Z',
      enableTime: true,
      minDate: 'today',
      minTime: '08:00',
      maxTime: '17:30',
      locale: {
        firstDayOfWeek: 1
      },
      disable: [
        function (date: Date) {
          return date.getDay() === 0 || date < new Date()
        }
      ]
    }
  }

  private buildEndDatePicker() {
    const inputElement = document.getElementById('hire-form-end-date')
    if (inputElement instanceof HTMLInputElement === false) return

    return flatpickr(inputElement, this.buildCommonOptions())
  }

  private buildStartDatePicker(endDateInstance: flatpickr.Instance | undefined) {
    const inputElement = document.getElementById('hire-form-start-date')
    if (inputElement instanceof HTMLInputElement === false) return

    const options = this.buildCommonOptions()
    if (endDateInstance) {
      options.onChange = function (selectedDates, _dateString, _instance) {
        endDateInstance.set('minDate', selectedDates[0])
      }
    }

    return flatpickr(inputElement, options)
  }

  private mountDatePickers() {
    this.buildStartDatePicker(this.buildEndDatePicker())
  }
}
